// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.el-radio-button__inner{\n    height: 50px!important;\n    text-align: center!important;\n    display: -webkit-box!important;\n    display: -ms-flexbox!important;\n    display: flex!important;\n    -webkit-box-align: center!important;\n        -ms-flex-align: center!important;\n            align-items: center!important;\n    white-space: pre-wrap!important;\n}\n.el-radio-button{\n    width: 39%!important;\n    margin-right: 20px!important;\n}\n", ""]);
// Exports
module.exports = exports;
